<template>
  <div class="mobile-menu" @click="isOpen=false">
    <!-- 汉堡菜单按钮 -->
    <div class="menu-toggle flex flex-item-center" >
      <div @click.stop="toggleMenu">
        <div class="bar" :class="{ 'bar1-active': isOpen }"></div>
        <div class="bar" :class="{ 'bar2-active': isOpen }"></div>
        <div class="bar" :class="{ 'bar3-active': isOpen }"></div>
      </div>
      <div class="font-size-28" style="flex:8">
        {{current.text}}
      </div>
    </div>

    <!-- 侧滑菜单内容 -->
    <transition name="slide">
      <div class="menu-content" v-show="isOpen">
        <div class="flex flex-row-around flex-item-center">
          <img style="width:40px;height:40px;border-radius: 20px" src="../../../public/default.png" alt="">
          <div class="flex flex-row-right flex-item-center" style="height:40px;">
            <el-radio-group @change="selectLang" v-model="lang" size="small">
              <el-radio-button :label="$t('lang.zh')" value="zh" />
              <el-radio-button :label="$t('lang.en')" value="en" />
            </el-radio-group>
          </div>
        </div>
        <ul>
          <li v-for="(item, index) in menuItems" :key="index" @click="selectItem(item)">
            {{ item.text }}
          </li>
        </ul>
      </div>
    </transition>
    <div class="other-view">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import {ElRadioGroup,ElRadioButton} from "element-plus";

export default {
  name: "mobileIndex",
  components:{
    ElRadioGroup,ElRadioButton
  },
  data() {
    return {
      lang:"zh",
      isOpen: false,
      menuItems: [
        { text: this.$t("mobile.index.return"), path: '/mobile' },
        { text: this.$t("mobile.index.toDoList"), path: '/toDoList' },
        { text: this.$t("mobile.index.shipment"), path: '/outList' },
        { text: this.$t("mobile.index.repair"), path: '/transferList' },
      ],
      current:{ text: this.$t("mobile.index.return"), path: '/mobile' },
    }
  },
  beforeMount() {
    this.lang = localStorage.getItem('lang') || "zh";
    // 页面加载时根据当前路由设置current
    const matchedItem = this.findMenuItemByPath(this.$route.path);
    if (matchedItem) {
      this.current = matchedItem;
    }
  },
  watch: {
    '$route'(to) {
      const matchedItem = this.findMenuItemByPath(to.path);
      if (matchedItem) {
        this.current = matchedItem;
      }
    }
  },
  methods: {
    findMenuItemByPath(path) {
      return this.menuItems.find(item => {
        // 特殊处理根路径
        if (item.path === '/mobile' && (path === '/' || path === '/mobile')) {
          return true;
        }
        // 其他路径使用startsWith进行匹配
        return path.startsWith(item.path);
      });
    },
    toggleMenu() {
      this.isOpen = !this.isOpen
    },
    selectItem(item) {
      console.log(item)
      this.current = item
      this.$router.push(item.path)
      this.isOpen = false
    },
    selectLang(){
      this.$i18n.locale = this.lang
      localStorage.setItem('lang',this.lang);
      window.location.reload()
    },
  }
}
</script>

<style scoped>
.mobile-menu {
  position: relative;
}

.menu-toggle {
  padding: 15px;
  cursor: pointer;
}

.bar {
  width: 25px;
  height: 3px;
  background-color: #333;
  margin: 5px 0;
  transition: 0.4s;
}

.bar1-active {
  transform: rotate(-45deg) translate(-5px, 6px);
}

.bar2-active {
  opacity: 0;
}

.bar3-active {
  transform: rotate(45deg) translate(-5px, -6px);
}

.menu-content {
  position: fixed;
  top: 0;
  left: 0;
  width: 50%;
  height: 100vh;
  background-color: #fff;
  box-shadow: 2px 0 5px rgba(0,0,0,0.2);
  z-index: 100;
  padding-top:20px;
}

.menu-content ul {
  list-style: none;
  padding: 0;
}

.menu-content li {
  padding: 15px 20px;
  border-bottom: 1px solid #eee;
}

.slide-enter-active, .slide-leave-active {
  transition: transform 0.3s ease;
}

.slide-enter, .slide-leave-to {
  transform: translateX(-100%);
}
</style>
